$('.masonry-container').masonry({
  itemSelector: '.masonry-box'
});

var count = 2;
var complete = false;
var loaded = true;

document.addEventListener("DOMContentLoaded", function() {
	jQuery('.masonry-container').each(function () {
		var masonry = jQuery(this).masonry({
			itemSelector: '.masonry-box'
		}).data('masonry');
		jQuery(window).on('load', function () {
			masonry.layout();
		});
	});
	document.addEventListener('scroll', scrollEvent);
});

function loadArticle(pageNumber) {
	count = count + 1;
	setSpinner(true);
	if(pageNumber !== count && loaded === true){
		loaded = false;
		$.ajax({
			url: "?page="+pageNumber,
			type:'POST',
			success: function(html){
				//apply the masonary
				
				if(html === ""){
					complete = true
					setSpinner(false);
					return false;
				}
				var masonryContainer = jQuery(".masonry-container");
				masonryContainer.append(html);
				masonryContainer.masonry( 'reloadItems' );
				masonryContainer.masonry( 'layout' );
				
				masonryContainer.imagesLoaded(function(){
					masonryContainer.masonry( 'reloadItems' );
					masonryContainer.masonry( 'layout' );
				});
				loaded = true;
				addEventListener(true);
				//hide the loader
				setSpinner(false)
			}
			
		});
	}
	// $(".masonry-box").addClass('masonry-box-visible');
	return true;
}

function setSpinner (toSet) {
	var loadingSpinner = document.querySelector("a#infinite-loader");
	if (toSet) {
		loadingSpinner.classList.add("js-show-loader");
	} else {
		loadingSpinner.classList.remove("js-show-loader");
	}
}

function scrollEvent () {
	var loading = document.querySelector("a#infinite-loader");
	if(complete){
		
	}else if(loading.classList.contains("js-show-loader") === false && (window.innerHeight + document.documentElement.scrollTop + 825) >= document.body.offsetHeight) {
		loadArticle(count);
	}
}

function addEventListener(isValid) {
	if (isValid !== false) {
		document.addEventListener("scroll", scrollEvent);
	}
}